import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useEffect, useRef, type FC } from "react";
import { type ConfigKey } from "./CountryList";
import countryConfig from "$/open_dict/country.json";
import { CountryIcon } from "./CountryIcon";
import { I18nNamespace } from "@/const/i18nNamespace";
import { Icon } from "@/assets/icon/Icon";
import { Pressable } from "./Pressable";

export const CountryListItem: FC<{
  code: ConfigKey;
  showTelCode?: boolean;
  isActived?: boolean;
  searchChat?: string;
  autoScrollIntoView?: boolean;
  onChange: (code: ConfigKey) => void;
}> = ({
  code,
  showTelCode,
  isActived,
  searchChat,
  autoScrollIntoView,
  onChange,
}) => {
  const { t } = useTranslation();

  const cRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (isActived && autoScrollIntoView) {
      cRef?.current?.scrollIntoView();
    }
  }, [isActived]);

  const highlightText = (text: string, search?: string) => {
    if (!search || !text) return text;

    const index = text.toLowerCase().indexOf(search.toLowerCase());
    if (index === -1) return text;

    return (
      <>
        {text.slice(0, index)}
        <span className="bg-color-fill text-color-primary mx-0.5 rounded-sm px-0.5 font-bold">
          {text.slice(index, index + search.length)}
        </span>
        {text.slice(index + search.length)}
      </>
    );
  };
  const residenceCountry = countryConfig[code].extra.code;
  const countryName = t(`${I18nNamespace.COUNTRY}:${code}`);

  return (
    <Pressable
      ref={cRef}
      key={code}
      className={twMerge(
        "border-b-color-border active:bg-color-fill-2 flex h-11 items-center gap-3 border-b px-6",
        isActived ? "text-color-primary" : "",
      )}
      style={{
        scrollMarginTop: 50,
      }}
      onPress={() => onChange(code)}
    >
      {showTelCode ? (
        <div className="flex flex-1 items-center gap-1 leading-4">
          <div className="w-12">{countryConfig[code].extra.tel}</div>
          <div>{highlightText(residenceCountry, searchChat)}</div>
          <div>/</div>
          <div>{highlightText(countryName, searchChat)}</div>
        </div>
      ) : (
        <>
          <CountryIcon
            code={countryConfig[code].extra.flag}
            className="text-shadow-sm text-2xl"
          />
          <div className="flex flex-1 items-center gap-1 leading-4">
            <div>{highlightText(residenceCountry, searchChat)}</div>
            <div>/</div>
            <div>{highlightText(countryName, searchChat)}</div>
          </div>
        </>
      )}
      {isActived ? <Icon type="checkArea" className="size-4" /> : null}
    </Pressable>
  );
};
